import Vue from 'vue';
import Vuex, { MutationTree, ActionTree, GetterTree } from 'vuex';

import { NewsState } from '../models/store-viewmodel';
import { root } from '@/shared/store/index';
import { Config } from '../models/config-viewmodel';
import { App } from '../models/app-viewmodel';

Vue.use(Vuex);

const state: NewsState = {
    apps: [],
    favoriteApps: [],
    loading: true,
    error: '',
    config: {
        language: '',
        overviewUrl: '',
        labels: {
            loading: '',
            linkText: '',
        },
        editMode: false
    }
}

const mutations: MutationTree<NewsState> = {
    setConfig(state, config: Config) {
        state.config = config;
    },

    setLoading(state, loading: boolean) {
        state.loading = loading;
    },

    setApps(state, apps: App[]) {
        state.apps = apps;
    },

    setFavoriteApps(state, apps: App[]) {
        state.favoriteApps = apps;
    },

    addFavoriteApp(state, app: App) {
        state.favoriteApps.push(app);
    },

    removeFavoriteApp(state, app: App) {
        state.favoriteApps.splice(state.favoriteApps.indexOf(app), 1);
    },

    setError(state, error: string) {
        state.error = error;
    }
}

const actions: ActionTree<NewsState, NewsState> = {
    setConfig(context, config: Config) {
        context.commit('setConfig', config)
    },

    setLoading(context, loading: boolean) {
        context.commit('setLoading', loading)
    },

    setApps(context, apps: App[]) {
        context.commit('setApps', apps)
    },

    setFavoriteApps(context, apps: App[]) {
        context.commit('setFavoriteApps', apps)
    },

    addFavoriteApp(context, app: App) {
        context.commit('addFavoriteApp', app)
    },

    removeFavoriteApp(context, app: App) {
        context.commit('removeFavoriteApp', app)
    },

    setError(context, error: string) {
        context.commit('setError', error)
    }
}

const getters: GetterTree<NewsState, NewsState> = {
    getConfig(state) {
        return state.config;
    },

    getFavoriteApps(state) {
        return state.favoriteApps;
    },

    getApps(state) {
        return state.apps;
    },

    getError(state) {
        return state.error;
    },

    getLoading(state) {
        return state.loading;
    }
}

export default new Vuex.Store({
    state,
    mutations,
    actions,
    getters,
    modules: {
        root
    }
})
